/**
 * 历史报价列表实体
 * zxw
 * 创建时间：2026-07-21
 * 修改时间：
 */

import React, { useState, useEffect, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { theme, Modal, Table, Tag, Statistic } from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    winHeight,
    winWidth,
} from '../../incs/FunHelper.js';

const HistoryOfferList = (props) => {
    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            fontSize,
        },
    } = theme.useToken();

    const { open, setOpen, record } = props;

    const [dataLists, setDataLists] = useState([]);

    const cancel = () => {
        setOpen(false);
    }

    useEffect(() => {
        if (!open) return;

        const params = {
            number: record.number,
        };
        $.ajax({
            url: `${CNF.api}projects/offers/lists${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        setDataLists(data.dat);
                    } else {
                        setDataLists([]);
                    }
                }
            }
        })

    }, [open, record.number])

    const columns = useMemo(() => [
        { title: '产品编码', dataIndex: 'number', key: 'number', fixed: 'left', width: 190, },
        { title: '产品名称', dataIndex: 'name', key: 'name', ellipsis: true, },
        { title: '规格型号', dataIndex: 'model', key: 'model', ellipsis: true, },
        { title: '品牌', dataIndex: 'brand', key: 'brand', ellipsis: true, },
        { title: '单位', dataIndex: 'unit', key: 'unit', ellipsis: true, width: 80, },
        { title: '报价名称', dataIndex: 'offer_name', key: 'offer_name', ellipsis: true, },
        {
            title: '报价版本', key: 'offer_version', width: 80,
            render: (record) => {
                return 'v' + record.offer_version;
            }
        },
        { title: '报价时间', dataIndex: 'create_time', key: 'create_time', width: 150, },
        { title: '初始单价(元)', dataIndex: 'init_price', key: 'init_price', width: 100, },
        {
            title: '历史报价(元)', key: 'audited_price', fixed: 'right', width: 150,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '70%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={parseFloat(record.audited_price)} /></Tag>

        },
    ], [colorPrimary, colorPrimaryBg, fontSize]);

    return <Modal
        width={winWidth > 200 ? winWidth - 200 : winWidth}
        height={winHeight}
        title='产品历史报价'
        style={{ top: 0, left: 100 }}
        open={open}
        onCancel={cancel}
        keyboard={true}
        footer={null}
    >
        <Table
            columns={columns}
            style={{ width: '100%' }}
            size='small'
            dataSource={dataLists}
            bordered={true}
            pagination={false}
            rowKey={(record) => record.key}
        />
    </Modal>
}

export default HistoryOfferList;